import type { ComponentPropsWithoutRef } from "react";
import { cn } from "../lib/utils";
import { TabsList, TabsTrigger } from "./ui/tabs";

export const PTS_PILL_TAB_TRIGGER_CLASS =
  "text-primary flex flex-1 items-center justify-center gap-2 rounded-lg px-3 py-2 text-sm font-medium data-[state=active]:border-b-0 data-[state=active]:bg-white data-[state=inactive]:bg-transparent data-[state=active]:text-gray-900 data-[state=active]:shadow-md";

interface PtsPillTabsListProps extends ComponentPropsWithoutRef<"div"> {
  listClassName?: string;
}

export const PtsPillTabsList = ({
  children,
  className,
  listClassName,
  ...props
}: PtsPillTabsListProps) => (
  <div
    className={cn("w-full rounded-xl bg-gray-100 p-[6px]", className)}
    {...props}
  >
    <TabsList
      className={cn(
        "inline-flex h-auto w-full bg-transparent p-0",
        listClassName
      )}
    >
      {children}
    </TabsList>
  </div>
);

interface PtsPillTabsTriggerProps
  extends ComponentPropsWithoutRef<typeof TabsTrigger> {}

export const PtsPillTabsTrigger = ({
  className,
  ...props
}: PtsPillTabsTriggerProps) => (
  <TabsTrigger
    className={cn(PTS_PILL_TAB_TRIGGER_CLASS, className)}
    {...props}
  />
);
